module.exports = __webpack_public_path__ + "static/card-img-6-aff2441e319dbbe82ee20f0db79ea215.jpg";